var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"results-analysis-table--container"},[_c('table',{staticClass:"elanco"},[_c('ResultsAnalysisTableHeader'),_c('ResultsAnalysisTableBody')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }